import React from 'react';
import Text from '../../../../ui/text';
import * as styles from './styles.module.scss';

const AutoSuggestionItem = ({ title, content, onClick }) => {
  return (
    <div className={styles.autoSuggestionItem} onClick={onClick}>
      <Text as="p" type="h3" dangerouslySetInnerHTML={{ __html: title }} />
      <Text as="p" dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

export default AutoSuggestionItem;
